import { OffersV2Header } from './OffersV2Header';
import { OffersV2Help } from './OffersV2Help';
import { OffersV2Customize } from './OffersV2Customize';
import { OffersV2Disclaimer } from './OffersV2Disclaimer';
import { OffersV2List } from './OffersV2List';
import {OffersV2ExpectationsCard } from './OffersV2ExpectationsCard';

export default {
    OffersV2Header,
    OffersV2Help,
    OffersV2Customize,
    OffersV2Disclaimer,
    OffersV2List,
    OffersV2ExpectationsCard,
};